export enum UserMfaType {
  NONE = 0,
  AUTHENTICATOR_APP = 1,
  EMAIL_VERIFICATION = 2,
}
